<template>
    <div class="scan-ticket-detail__list-table">
        <div class="scan-ticket-detail__table">
            <span class="scan-ticket-detail__table-title">{{ getTranslatedText('ticket') }}</span>
            <table>
                <thead>
                    <tr>
                        <th>{{ getTranslatedText('no') }}</th>
                        <th>{{ getTranslatedText('select') }}</th>
                        <th>{{ getTranslatedText('game') }}</th>
                        <th>{{ getTranslatedText('wager') }}</th>
                        <th>{{ getTranslatedText('winnings') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(v, i) in details" :key="i">
                        <td>#{{ i + 1 }}</td>
                        <td v-if="v.game_name === INSTANT_SLUG_GAME">
                            <div class="scan-ticket-detail__table-list-number mb" v-for="(bet, index) in v.bet.bets" :key="index">
                                <span v-if="index > 0">+</span>
                                <div class="scan-ticket-detail__table-item-number" v-for="(number, j) in renderItemBalls(1, bet)" :key="j">
                                    {{ number }}
                                </div>
                            </div>
                            <div class="scan-ticket-detail__table-list-number" v-for="(bet, index) in v.bet.bets" :key="index">
                                <span v-if="index > 0">+</span>
                                <div class="scan-ticket-detail__table-item-number" v-for="(number, j) in renderItemBalls(2, bet)" :key="j">
                                    {{ number }}
                                </div>
                            </div>
                        </td>
                        <td v-else>
                            <div class="scan-ticket-detail__table-list-number" v-for="(bet, index) in v.bet.bets" :key="index">
                                <span v-if="index > 0">+</span>
                                <div class="scan-ticket-detail__table-item-number" v-for="(number, j) in bet" :key="j">
                                    {{ number }}
                                </div>
                            </div>
                        </td>
                        <td>
                            {{ renderGameName(v.game_name) }}
                        </td>
                        <td>{{ renderPrice(v.wager) }} </td>
                        <td :class="[{'scan-ticket-detail__line': v.game_name === INSTANT_SLUG_GAME}]">
                            <span v-if="v.game_name === INSTANT_SLUG_GAME">|</span>
                            {{ v.winnings ? renderPrice(v.winnings) : '0.00' }}<span v-if="v.freebet_quantity > 0" class="scan-ticket-detail__freebet-note"> ({{ v.freebet_quantity }} {{ getTranslatedText('free spin') }})</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="scan-ticket-detail__table">
            <span class="scan-ticket-detail__table-title">{{ getTranslatedText('draw') }}</span>
            <div class="scan-ticket-detail__table-item-draw" v-for="(value, index) in events" :key="index">
                <div class="scan-ticket-detail__table-item">
                    <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('draw date') }}</span>
                    <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value"> {{ renderDate(value.draw_date) }} </span>
                </div>
                <div v-if="value.is_double_chance_game == true">
                    <div class="scan-ticket-detail__table-item" >
                        <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('premier results') }} </span>
                        <template v-if="value.results && value.results.length > 0">
                            <div class="scan-ticket-detail__table-list-number" v-for="(bet, index) in value.results" :key="index">
                                <template>
                                    <span v-if="index > 0">+</span>
                                    <div class="scan-ticket-detail__table-item-number" v-for="(number, j) in bet" :key="j">
                                        {{ number }}
                                    </div>
                                </template>
                            </div>
                        </template>
                        <span v-else class="scan-ticket-detail__pending-results">
                            {{ getTranslatedText('pending results') }}
                        </span>
                    </div>
                    <div class="scan-ticket-detail__table-item" >
                        <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('double chance result') }} </span>
                        <template v-if="value.double_chance_results && value.double_chance_results.length > 0">
                            <div class="scan-ticket-detail__table-list-number" v-for="(bet, index) in value.double_chance_results" :key="index">
                                <template>
                                    <span v-if="index > 0">+</span>
                                    <div class="scan-ticket-detail__table-item-number" v-for="(number, j) in bet" :key="j">
                                        {{ number }}
                                    </div>
                                </template>
                            </div>
                        </template>
                        <span v-else class="scan-ticket-detail__pending-results">
                            {{ getTranslatedText('pending results') }}
                        </span>
                    </div>
                </div>
                <div class="scan-ticket-detail__table-item" v-else>
                    <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('result') }} </span>
                    <template v-if="value.results && value.results.length > 0">
                        <div class="scan-ticket-detail__table-list-number" v-for="(bet, index) in value.results" :key="index">
                            <template  v-if="bet.length > INSTANT_DETAIL_LIMIT_SHOW_NUMBER_LINE_RESULT">
                                <div class="scan-ticket-detail__table-list-number-box">
                                    <div class="scan-ticket-detail__table-list-number-column">
                                        <div class="scan-ticket-detail__table-item-number" v-for="(number, j) in renderItemBalls(1, bet, INSTANT_DETAIL_LIMIT_SHOW_NUMBER_LINE_RESULT)" :key="j">
                                            {{ number }}
                                        </div>
                                    </div>
                                    <div class="scan-ticket-detail__table-list-number-column">
                                        <div class="scan-ticket-detail__table-item-number" v-for="(number, j) in renderItemBalls(2, bet, INSTANT_DETAIL_LIMIT_SHOW_NUMBER_LINE_RESULT)" :key="j">
                                            {{ number }}
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <span v-if="index > 0">+</span>
                                <div class="scan-ticket-detail__table-item-number" v-for="(number, j) in bet" :key="j">
                                    {{ number }}
                                </div>
                            </template>
                        </div>
                    </template>
                    <span v-else class="scan-ticket-detail__pending-results">
                        {{ getTranslatedText('pending results') }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { INSTANT_DETAIL_LIMIT_SHOW_NUMBER_LINE_RESULT, INSTANT_SLUG_GAME } from '@/constants/lotto';
import languageMixins from '@/mixins/language/language-mixins'

import { formatDateUTC00, formatPrice, splitDataLottoInstant } from '@/utils/utils'

export default {
    mixins: [languageMixins],
    props: {
        details: {
            type: Array,
            default: () => [],
        },
        events: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            INSTANT_SLUG_GAME,
            INSTANT_DETAIL_LIMIT_SHOW_NUMBER_LINE_RESULT
        }
    },
    methods: {
        renderItemBalls(type, data, number) {            
           return splitDataLottoInstant(type, data, number)
        },

        renderGameName(name) {
            const arrName = name.split(' - ')
            if(arrName?.length > 1) {
                let game_name = '' 
                arrName.forEach((item, index) => {
                    if (index > 0) game_name += ' - '
                    game_name += this.getTranslatedText(item)
                });
                return game_name
            }
            return this.getTranslatedText(name)
        },

        renderDate(date) {
            const dateFormat = formatDateUTC00(date)

            let valueDate = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}`

            return valueDate
        },

        renderPrice(price) {
            return formatPrice(price)
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/scan-ticket/_detail.scss';

.scan-ticket-detail__freebet-note {
    display: inline-block;
    white-space: nowrap;
    color: #b07a00;
    font-weight: 600;
}
</style>
